<template>
  <div class="row align-items-center">
    <!-- drag handle -->
    <div class="col-auto drag-handle" style="cursor: move;">
      <Icon icon="fa-solid:grip-vertical" />
    </div>

    <!-- count -->
    <div class="col-auto mb-3">
      <div class="form-floating">
        <Field
            :id="`component_count_${index}`"
            :name="fieldName('count')"
            as="select"
            class="form-select count-select text-end" :class="{'is-invalid': errors[fieldName('count')]}">
          <option value="0" class="text-end">k. A.</option>
          <option v-for="n in 15" :key="n" :value="n" class="text-end">{{ n }}x</option>
        </Field>
        <label :for="`component_count_${index}`">Anzahl</label>
        <ErrorMessage :name="fieldName('count')" :class="errorMessageClasses"/>
      </div>
    </div>

    <!-- name -->
    <div class="col col-lg-8 mb-3">
      <div class="form-floating">
        <Field
            :id="`name_${index}`"
            :name="fieldName('name')"
            class="form-control" :class="{'is-invalid': errors[fieldName('name')]}"
            required
        />
        <label :for="`name_${index}`">Leistung</label>
        <ErrorMessage :name="fieldName('name')" :class="errorMessageClasses"/>
      </div>
    </div>

    <!-- btn delete -->
    <div class="col-auto">
      <button type="button" class="btn btn-sm btn-secondary" @click="remove(index)">
        <Icon icon="fa-pro-solid:trash" class="me-2"/>
      </button>
    </div>
  </div>
</template>

<script>

import {ErrorMessage, Field} from "vee-validate";

export default {
  name: 'ComponentFormFields',
  components: {
    ErrorMessage,
    Field,
  },
  props: {
    index: {
      type: Number,
    },
    remove: Function,
    errors: Object,
    errorMessageClasses: String,
  },
  data() {
    return {
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    fieldName(attribute) {
      return `components_data[${this.index}].${attribute}`
    },
  },
}
</script>

<style scoped>
.count-select {
  width: 7rem;
  /* Keep the count clear of the chevron. */
  padding-right: 2.75rem;
}

.count-select option {
  text-align: right;
}

/* Styleable popup (Chromium 135+); other browsers keep the native one. */
@supports (appearance: base-select) {
  .count-select,
  .count-select::picker(select) {
    appearance: base-select;
  }

  /* Bootstrap draws the chevron as background image already. */
  .count-select::picker-icon {
    display: none;
  }

  .count-select::picker(select) {
    margin-top: 0.25rem;
    padding: 0.25rem 0;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    box-shadow: var(--bs-box-shadow);
  }

  .count-select option {
    justify-content: flex-end;
    padding: 0.375rem 2.75rem 0.375rem 0.75rem;
  }

  .count-select option::checkmark {
    display: none;
  }

  .count-select option:hover,
  .count-select option:focus-visible {
    background-color: var(--bs-secondary-bg);
  }

  .count-select option:checked {
    background-color: var(--bs-primary-bg-subtle);
    font-weight: 600;
  }
}
</style>

